import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { LoaderModule } from '@progress/kendo-angular-indicators';
import { TextAreaModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { CardModule, GridLayoutModule } from '@progress/kendo-angular-layout';
import { faSave } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-cancel-request',
    imports: [GridLayoutModule,
        LabelModule,
        ButtonModule,
        ReactiveFormsModule,
        TextAreaModule,
        LoaderModule,
        FontAwesomeModule,
        CardModule],
    templateUrl: './cancel-request.component.html',
    styleUrls: ['./cancel-request.component.css']
})
export class CancelRequestComponent implements OnInit {

  @Output() submitForm: EventEmitter<FormGroup> = new EventEmitter();

  form: FormGroup;
  isNew: boolean;

  saving: boolean = false;
  saveIcon = faSave;

  constructor(private fb: FormBuilder) { }

  ngOnInit() {

    this.form = this.fb.group({
      message: ['', Validators.required]
    })
  }

  save(): void {
    this.saving = true;
    this.submitForm.emit(this.form);
  }

}

